package org.solyton.solawi.bid.module.shares.`data`.subscriptions

import kotlin.Boolean
import kotlin.Double
import kotlin.Int
import kotlin.String
import kotlin.collections.List
import kotlinx.datetime.LocalDateTime
import org.evoleq.axioms.definition.ReadOnly
import org.evoleq.axioms.definition.ReadWrite
import org.evoleq.optics.lens.Lens
import org.solyton.solawi.bid.module.shares.`data`.`internal`.ShareStatus

/**
 * Autogenerated ReadOnly Lens.
 * Read [ShareSubscription.shareSubscriptionId]
 */
@ReadOnly
public val shareSubscriptionId: Lens<ShareSubscription, String> by lazy {
      Lens(
        get = { whole -> whole.shareSubscriptionId },
        set = { { it } }
      )}


/**
 * Autogenerated Lens.
 * Read and manipulate [ShareSubscription.providerId]
 */
@ReadWrite
public val providerId: Lens<ShareSubscription, String> by lazy {
      Lens(
        get = { whole -> whole.providerId },
        set = { part -> { whole -> whole.copy(providerId = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ShareSubscription.providerId]
 */
@ReadWrite
public fun ShareSubscription.providerId(`set`: String.() -> String): ShareSubscription =
    copy(providerId = set(providerId))

/**
 * Autogenerated Lens.
 * Read and manipulate [ShareSubscription.shareOfferId]
 */
@ReadWrite
public val shareOfferId: Lens<ShareSubscription, String> by lazy {
      Lens(
        get = { whole -> whole.shareOfferId },
        set = { part -> { whole -> whole.copy(shareOfferId = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ShareSubscription.shareOfferId]
 */
@ReadWrite
public fun ShareSubscription.shareOfferId(`set`: String.() -> String): ShareSubscription =
    copy(shareOfferId = set(shareOfferId))

/**
 * Autogenerated Lens.
 * Read and manipulate [ShareSubscription.userProfileId]
 */
@ReadWrite
public val userProfileId: Lens<ShareSubscription, String> by lazy {
      Lens(
        get = { whole -> whole.userProfileId },
        set = { part -> { whole -> whole.copy(userProfileId = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ShareSubscription.userProfileId]
 */
@ReadWrite
public fun ShareSubscription.userProfileId(`set`: String.() -> String): ShareSubscription =
    copy(userProfileId = set(userProfileId))

/**
 * Autogenerated Lens.
 * Read and manipulate [ShareSubscription.distributionPointId]
 */
@ReadWrite
public val distributionPointId: Lens<ShareSubscription, String?> by lazy {
      Lens(
        get = { whole -> whole.distributionPointId },
        set = { part -> { whole -> whole.copy(distributionPointId = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ShareSubscription.distributionPointId]
 */
@ReadWrite
public fun ShareSubscription.distributionPointId(`set`: String?.() -> String?): ShareSubscription =
    copy(distributionPointId = set(distributionPointId))

/**
 * Autogenerated Lens.
 * Read and manipulate [ShareSubscription.fiscalYearId]
 */
@ReadWrite
public val fiscalYearId: Lens<ShareSubscription, String> by lazy {
      Lens(
        get = { whole -> whole.fiscalYearId },
        set = { part -> { whole -> whole.copy(fiscalYearId = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ShareSubscription.fiscalYearId]
 */
@ReadWrite
public fun ShareSubscription.fiscalYearId(`set`: String.() -> String): ShareSubscription =
    copy(fiscalYearId = set(fiscalYearId))

/**
 * Autogenerated Lens.
 * Read and manipulate [ShareSubscription.numberOfShares]
 */
@ReadWrite
public val numberOfShares: Lens<ShareSubscription, Int> by lazy {
      Lens(
        get = { whole -> whole.numberOfShares },
        set = { part -> { whole -> whole.copy(numberOfShares = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ShareSubscription.numberOfShares]
 */
@ReadWrite
public fun ShareSubscription.numberOfShares(`set`: Int.() -> Int): ShareSubscription =
    copy(numberOfShares = set(numberOfShares))

/**
 * Autogenerated Lens.
 * Read and manipulate [ShareSubscription.pricePerShare]
 */
@ReadWrite
public val pricePerShare: Lens<ShareSubscription, Double?> by lazy {
      Lens(
        get = { whole -> whole.pricePerShare },
        set = { part -> { whole -> whole.copy(pricePerShare = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ShareSubscription.pricePerShare]
 */
@ReadWrite
public fun ShareSubscription.pricePerShare(`set`: Double?.() -> Double?): ShareSubscription =
    copy(pricePerShare = set(pricePerShare))

/**
 * Autogenerated Lens.
 * Read and manipulate [ShareSubscription.ahcAuthorized]
 */
@ReadWrite
public val ahcAuthorized: Lens<ShareSubscription, Boolean?> by lazy {
      Lens(
        get = { whole -> whole.ahcAuthorized },
        set = { part -> { whole -> whole.copy(ahcAuthorized = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ShareSubscription.ahcAuthorized]
 */
@ReadWrite
public fun ShareSubscription.ahcAuthorized(`set`: Boolean?.() -> Boolean?): ShareSubscription =
    copy(ahcAuthorized = set(ahcAuthorized))

/**
 * Autogenerated Lens.
 * Read and manipulate [ShareSubscription.status]
 */
@ReadWrite
public val status: Lens<ShareSubscription, ShareStatus> by lazy {
      Lens(
        get = { whole -> whole.status },
        set = { part -> { whole -> whole.copy(status = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ShareSubscription.status]
 */
@ReadWrite
public fun ShareSubscription.status(`set`: ShareStatus.() -> ShareStatus): ShareSubscription =
    copy(status = set(status))

/**
 * Autogenerated Lens.
 * Read and manipulate [ShareSubscription.coSubscribers]
 */
@ReadWrite
public val coSubscribers: Lens<ShareSubscription, List<String>> by lazy {
      Lens(
        get = { whole -> whole.coSubscribers },
        set = { part -> { whole -> whole.copy(coSubscribers = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ShareSubscription.coSubscribers]
 */
@ReadWrite
public fun ShareSubscription.coSubscribers(`set`: List<String>.() -> List<String>):
    ShareSubscription = copy(coSubscribers = set(coSubscribers))

/**
 * Autogenerated ReadOnly Lens.
 * Read [ShareSubscription.statusUpdatedAt]
 */
@ReadOnly
public val statusUpdatedAt: Lens<ShareSubscription, LocalDateTime?> by lazy {
      Lens(
        get = { whole -> whole.statusUpdatedAt },
        set = { { it } }
      )}


/**
 * Autogenerated ReadOnly Lens.
 * Read [ShareSubscription.pendingRolloverCompanion]
 */
@ReadOnly
public val pendingRolloverCompanion: Lens<ShareSubscription, String?> by lazy {
      Lens(
        get = { whole -> whole.pendingRolloverCompanion },
        set = { { it } }
      )}

